import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=22e81411&scoped=true&"
import script from "./ContentContainer.vue?vue&type=script&lang=js&"
export * from "./ContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=22e81411&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e81411",
  null
  
)

export default component.exports